import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/admin-login.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    if (!email || !password) return setError('Please fill in all fields');
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/auth/login`, { email, password });
      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminUser', JSON.stringify(response.data.admin));
        navigate('/admin/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login-page">
      <SEO title="Admin Login" path="/admin/login" noindex />

      <div className="admin-login-card">
        <h1>Admin Login</h1>
        <p>Sign in to manage certificates</p>
        {error && <div className="error-box">{error}</div>}
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading} />
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} />
          <button type="submit" className="primary-btn">{loading ? 'Logging in...' : 'Login'}</button>
        </form>
      </div>
    </div>
  );
}
